export const normalizeItem = (values) => {
    const { price, vehicleCount } = values;

    return {
        ...values,
        vehicleCount: parseInt(vehicleCount),
        price: {
            amount: parseInt(parseFloat(price) * 100),
            currency: 'EUR'
        }
    };
};
